import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  productGridImportsButton: {
    description: 'Import products button',
    defaultMessage: 'Import',
    id: '/3gnGJ',
  },
  importProductsOption: {
    description: 'Products Grid Actions Import Dropdown Option',
    defaultMessage: 'Import Products',
    id: 'DfWWLz',
  },
  importAliasesOption: {
    description: 'Products Grid Actions Import Alias Dropdown Option',
    defaultMessage: 'Import Product Aliases',
    id: 'hPHm1N',
  },
  importDangerousGoodsOption: {
    description: 'Products Grid Actions Import Dangerous Goods Dropdown Option',
    defaultMessage: 'Import Product Dangerous Goods',
    id: 'XzOcrd',
  },
  importBundlesOption: {
    description: 'Products Grid Actions Import Bundles Dropdown Option',
    defaultMessage: 'Import Product Bundles',
    id: 'ALjMGS',
  },
  importProductUomOption: {
    description: 'Products Grid Actions Import Units of Measure Dropdown Option',
    defaultMessage: 'Import Units of Measure',
    id: 'h8arne',
  },
});
